import { QrCodeIcon } from '@hugeicons/core-free-icons';
import { LuIndentIncrease } from 'react-icons/lu';
import {
  TbAlertTriangle,
  TbBrandStackoverflow,
  TbCircleCheck,
  TbCircleDashed,
  TbCircleMinus,
  TbCirclePlus,
  TbClockPause,
  TbRouteOff,
  TbRouteSquare,
} from 'react-icons/tb';

import { createHugeIcon } from './create-huge-icon';
import { createReactIcon } from './create-react-icon';

export const WorkOrdersIcon = createReactIcon(TbBrandStackoverflow, 'WorkOrdersIcon');
export const RunSheetsIcon = createReactIcon(TbRouteSquare, 'RunSheetsIcon');
export const ReleaseIcon = createReactIcon(LuIndentIncrease, 'ReleaseIcon');
export const QRCodeIcon = createHugeIcon(QrCodeIcon, 'QRCodeIcon');
export const DraftStateIcon = createReactIcon(TbCircleDashed, 'DraftStateIcon');
export const StagedStateIcon = createReactIcon(TbClockPause, 'StagedStateIcon');
export const LiveStateIcon = createReactIcon(TbCircleCheck, 'LiveStateIcon');
export const RouteOffIcon = createReactIcon(TbRouteOff, 'RouteOffIcon');
export const IncludeRuleIcon = createReactIcon(TbCirclePlus, 'IncludeRuleIcon');
export const ExcludeRuleIcon = createReactIcon(TbCircleMinus, 'ExcludeRuleIcon');
export const AlertTriangleIcon = createReactIcon(TbAlertTriangle, 'AlertTriangleIcon');
